import { Box, Stack } from '@mui/material';
import { keyframes, styled } from '@mui/system';
import { FunctionComponent, useEffect } from 'react';

//import { TypePinEntryBoxes } from '../../mobile-app-components/types/settingListOptions';

type TypePinEntryBoxes = {
    'ani': boolean,
    'boxNum': number,
    'dots': boolean,
    'pin': string
}

//todo : replace entry count
const PinEntryBoxes: FunctionComponent<TypePinEntryBoxes> = ({ ani, boxNum, dots, pin }) => {

    const shake = keyframes`
        0%  { transform: translate(4px) }
        10% { transform: translate(-2px)}
        20% { transform: translate(-6px)}
        30% { transform: translate(0px) }
        40% { transform: translate(2px) }
        50% { transform: translate(-2px)}
        60% { transform: translate(-6px)}
        70% { transform: translate(4px)}
        80% { transform: translate(-2px)}
        90% { transform: translate(4px)}
        100%{ transform: translate(2px )}
        `;

    const failedEntryColorChange = keyframes` 
        0% {border-color: red;}
        100% {border-color: #84CAFF;}
    `;

    const NumEntry = styled("div")(({theme}:{theme:any}) => ({
        fontSize: theme.spacing(4),
        //verticalAlign: 'middle',
        textAlign: 'center',
        verticalAlign: 'middle',
        position: 'relative',
        background: 'white',
        border: '2px solid',
        borderColor: theme.palette.dsPrimary.v200, //update to use theme 
        borderRadius: theme.spacing(0.5),
        width: theme.spacing(6),
        lineHeight: theme.spacing(6),
        height: theme.spacing(6),
        //animation: `${failedEntryColorChange} 0.5s`,
        animation:  `${ani ? failedEntryColorChange: null} 1s`, 
    }));

    useEffect(() => {
        //setChangeColor(ani);
    }, [ani, dots, pin]);

    //todo: put into file

    const PinDot = styled(Box)(({ }) => ({
        position: 'absolute',
        left: '50%',
        top: '50%',
        // -ms-transform: 'translateY(-50%)',
        borderRadius: '50%',
        transform: 'translateY(-50%)  translateX(-50%) ',
        background: 'black',
        width: '13px',
        height: '13px'
    }));


    const AniBox = styled(Box)(({ }) => ({
        animation: `${ani ? shake : null} 0.5s`
    }));


    //todo: update function use map
    const createBoxes = () => {

        // //add 
        let boxes = [];
        for (let i = 0; i < boxNum; i++) {
            boxes.push(
                <Box
                    style={{ display: 'flex' }}
                    key={i}>
                    <NumEntry>
                        {/* {entryCount <= boxNum ? */}
                        {pin[i] != null ?
                            dots ? <PinDot /> : pin[i]
                            : null
                        }
                    </NumEntry >
                </Box>)

        }
        return (<Stack spacing={1} direction='row'>
            {boxes}
        </Stack>)
    }

    return ( //todo: set with loop

        <div style={{
            display: 'flex',
            margin: 'auto',
            width: '100%',
            justifyContent: 'center',
            alignContent: 'center'

        }}>

            {/* //aniBox goes here */}
            <AniBox>
                {createBoxes()}
            </AniBox>
        </div>
    )
};

export default PinEntryBoxes;
